import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseButton } from '../components/base-button/Component.js';
import 'react-merge-refs';
import 'classnames';
import '../../../shared/esm';
import '../../../spinner/esm';
import '@alfalab/hooks';

var defaultColors = {"primary":"button__primary_p8nl1","loader":"button__loader_p8nl1","secondary":"button__secondary_p8nl1","ghost":"button__ghost_p8nl1","component":"button__component_p8nl1","loading":"button__loading_p8nl1","tertiary":"button__tertiary_p8nl1","link":"button__link_p8nl1"};
require('./default.mobile.css');

var invertedColors = {"primary":"button__primary_s8inj","loader":"button__loader_s8inj","secondary":"button__secondary_s8inj","ghost":"button__ghost_s8inj","component":"button__component_s8inj","loading":"button__loading_s8inj","tertiary":"button__tertiary_s8inj","link":"button__link_s8inj"};
require('./inverted.mobile.css');

var styles = {"xxs":"button__xxs_79qfz","xs":"button__xs_79qfz","s":"button__s_79qfz","m":"button__m_79qfz","l":"button__l_79qfz","xl":"button__xl_79qfz"};
require('./mobile.css');

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var ButtonMobile = forwardRef(function (restProps, ref) { return (React.createElement(BaseButton, __assign({}, restProps, { ref: ref, colorStylesMap: colorStyles, styles: styles }))); });

export { ButtonMobile };
